<form class="row" [formGroup]="form" (ngSubmit)="search()">
  <div class="col-6 pr-3">
    <div class="form-group" [ngClass]="{ 'form-error': cvrValidator.errors }">
      <label for="input" class="form-label">{{ 'CvrOrPNummer' | tekstresource }}</label>
      <input type="text" id="input" class="form-input" [placeholder]="'SkrivCvrOrPNummer' | tekstresource"
        formControlName="cvrValidator" (ngModelChange)="inputChange($event)" (blur)="onBlur()" />
      <span *ngIf="cvrValidator.errors" class="form-error-message">
        {{ 'CvrPnummerInputValidering' | tekstresource }}</span>
    </div>
  </div>
  <div class="col-6">
    <div class="form-group" [ngClass]="{ 'form-error': pNummerValidator.errors }">
      <label for="pnumreSelect" class="form-label">{{ 'PNummer' | tekstresource }}</label>
      <ng-container *ngIf="!searching; else showPnummerLoading">
        <select id="pnumreSelect" class="form-select" formControlName="pnummerValidator"
          (ngModelChange)="pnummerChange()">
          <option *ngFor="let option of pEnhedOptions" [ngValue]="option">
            {{ option.pNummer }}
            <ng-container *ngIf="option.fuldAdresse">- {{ option.fuldAdresse }}</ng-container>
          </option>
        </select>
        <span *ngIf="pNummerValidator.errors" class="form-error-message">
          {{ 'PnummerIkkeValgt' | tekstresource }}
        </span>
      </ng-container>
      <ng-template #showPnummerLoading><bom-spinner size="small" class="loading"></bom-spinner>
      </ng-template>
    </div>
  </div>
</form>